import "core-js/modules/es.array.map.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.concat.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import merge from "lodash/merge";
import { CommonTypes } from "./types";
import { formatAMPM, formatDate, parseDate } from "@dp/common";
import moment from "moment-timezone";
import { LocationTimeUIError, UIError } from "./errors";

var Times = /*#__PURE__*/function () {
  function Times(config, axios) {
    _classCallCheck(this, Times);

    _defineProperty(this, "axios", void 0);

    _defineProperty(this, "config", void 0);

    this.axios = axios;
    this.config = config;
  }

  _createClass(Times, [{
    key: "setOrderRestaurantAndPickupTime",
    value: function () {
      var _setOrderRestaurantAndPickupTime = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(requestedPickupDateTime, restaurantNum, orderId, jwtToken) {
        var asapSelected,
            validateCartItems,
            orderType,
            payload,
            requestedPickupDate,
            requestedPickupTime,
            headers,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                asapSelected = _args.length > 4 && _args[4] !== undefined ? _args[4] : false;
                validateCartItems = _args.length > 5 && _args[5] !== undefined ? _args[5] : false;
                orderType = _args.length > 6 && _args[6] !== undefined ? _args[6] : 0;
                payload = {
                  validateCartItems: validateCartItems,
                  restaurantNum: restaurantNum,
                  asapSelected: asapSelected,
                  orderId: orderId,
                  orderType: orderType
                };

                if (orderId) {
                  payload.orderId = orderId;
                }

                if (requestedPickupDateTime) {
                  requestedPickupDate = formatDate(requestedPickupDateTime);
                  requestedPickupTime = formatAMPM(requestedPickupDateTime);
                  payload.requestedPickupDate = requestedPickupDate;
                  payload.requestedPickupTime = requestedPickupTime;
                }

                headers = {
                  "x-retry-on-timeout": true
                };

                if (jwtToken) {
                  headers["Authorization"] = "Bearer ".concat(jwtToken);
                }

                _context.next = 10;
                return this.axios.put(this.config.postfix.LOCATION_TIME, payload, {
                  headers: headers
                }).then(function (resp) {
                  var _resp$data;

                  return resp === null || resp === void 0 ? void 0 : (_resp$data = resp.data) === null || _resp$data === void 0 ? void 0 : _resp$data.response;
                })["catch"](function (err) {
                  throw new LocationTimeUIError(err);
                });

              case 10:
                return _context.abrupt("return", _context.sent);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function setOrderRestaurantAndPickupTime(_x, _x2, _x3, _x4) {
        return _setOrderRestaurantAndPickupTime.apply(this, arguments);
      }

      return setOrderRestaurantAndPickupTime;
    }()
  }, {
    key: "setOrderPickupTime",
    value: function () {
      var _setOrderPickupTime = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(requestedPickupDateTime, orderId, jwtToken) {
        var asapSelected,
            validateCartItems,
            payload,
            requestedPickupDate,
            requestedPickupTime,
            headers,
            _args2 = arguments;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                asapSelected = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : false;
                validateCartItems = _args2.length > 4 && _args2[4] !== undefined ? _args2[4] : true;
                payload = {
                  asapSelected: asapSelected,
                  validateCartItems: validateCartItems,
                  orderId: orderId
                };

                if (requestedPickupDateTime) {
                  requestedPickupDate = formatDate(requestedPickupDateTime);
                  requestedPickupTime = formatAMPM(requestedPickupDateTime);
                  payload.requestedPickupDate = requestedPickupDate;
                  payload.requestedPickupTime = requestedPickupTime;
                }

                headers = {
                  "x-retry-on-timeout": true
                };

                if (jwtToken) {
                  headers["Authorization"] = "Bearer ".concat(jwtToken);
                }

                _context2.next = 8;
                return this.axios.put(this.config.postfix.SETPICKUP_TIME, payload, {
                  headers: headers
                }).then(function (resp) {
                  var _resp$data2;

                  var response = resp === null || resp === void 0 ? void 0 : (_resp$data2 = resp.data) === null || _resp$data2 === void 0 ? void 0 : _resp$data2.response;
                  return merge(response, {
                    actualPickupDateTime: response === null || response === void 0 ? void 0 : response.actualPickupTime.time
                  });
                })["catch"](function (err) {
                  throw new LocationTimeUIError(err);
                });

              case 8:
                return _context2.abrupt("return", _context2.sent);

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function setOrderPickupTime(_x5, _x6, _x7) {
        return _setOrderPickupTime.apply(this, arguments);
      }

      return setOrderPickupTime;
    }()
  }, {
    key: "getPickupTimes",
    value: function () {
      var _getPickupTimes = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(jwtToken, restaurantNum, pickupDate) {
        var _this = this;

        var orderType,
            isRealTime,
            orderId,
            commonQueryParams,
            locale,
            headers,
            _args3 = arguments;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                orderType = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : 0;
                isRealTime = _args3.length > 4 && _args3[4] !== undefined ? _args3[4] : false;
                orderId = _args3.length > 5 ? _args3[5] : undefined;
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams !== null && commonQueryParams !== void 0 && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                headers = _defineProperty({}, CommonTypes.APIHeaders.Authorization, "Bearer ".concat(jwtToken));
                !jwtToken && delete headers[CommonTypes.APIHeaders.Authorization];
                _context3.next = 9;
                return this.axios.get(this.config.postfix.PICKUP_TIMES, {
                  params: {
                    locale: locale,
                    restaurantNum: restaurantNum,
                    orderType: "".concat(orderType),
                    pickupDate: formatDate(pickupDate),
                    isRealTime: "".concat(isRealTime),
                    orderId: orderId
                  },
                  headers: headers
                }).then(function (response) {
                  var _response$data;

                  return _this._processPickupTimesResponse(response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.response, pickupDate);
                })["catch"](function (err) {
                  throw new UIError(err);
                });

              case 9:
                return _context3.abrupt("return", _context3.sent);

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getPickupTimes(_x8, _x9, _x10) {
        return _getPickupTimes.apply(this, arguments);
      }

      return getPickupTimes;
    }()
  }, {
    key: "_processPickupTimesResponse",
    value: function _processPickupTimesResponse(responseData, pickupDate) {
      var _responseData$capacit, _responseData$capacit2, _responseData$capacit3, _responseData$capacit6, _responseData$capacit7, _responseData$capacit8, _responseData$capacit9, _responseData$capacit10, _responseData$times, _responseData$times2, _responseData$times2$, _responseData$restaur;

      var pickupDateStr = formatDate(pickupDate);
      return merge(responseData, {
        currentTime: responseData.currentTime ? {
          dateTime: responseData.currentTime.time ? moment(responseData.currentTime.time).toDate() : null
        } : null,
        capacitySlots: responseData.capacitySlots ? {
          availableSlots: (_responseData$capacit = responseData.capacitySlots) !== null && _responseData$capacit !== void 0 && _responseData$capacit.availableSlots ? responseData === null || responseData === void 0 ? void 0 : (_responseData$capacit2 = responseData.capacitySlots) === null || _responseData$capacit2 === void 0 ? void 0 : (_responseData$capacit3 = _responseData$capacit2.availableSlots) === null || _responseData$capacit3 === void 0 ? void 0 : _responseData$capacit3.map(function (slot) {
            var _responseData$capacit4, _responseData$capacit5;

            return {
              endDateTime: slot.endTime ? moment((responseData === null || responseData === void 0 ? void 0 : (_responseData$capacit4 = responseData.capacitySlots) === null || _responseData$capacit4 === void 0 ? void 0 : _responseData$capacit4.capacityDate) + " " + (slot === null || slot === void 0 ? void 0 : slot.endTime)).toDate() : null,
              lowInventory: slot === null || slot === void 0 ? void 0 : slot.lowInventory,
              startDateTime: slot !== null && slot !== void 0 && slot.startTime ? moment((responseData === null || responseData === void 0 ? void 0 : (_responseData$capacit5 = responseData.capacitySlots) === null || _responseData$capacit5 === void 0 ? void 0 : _responseData$capacit5.capacityDate) + " " + (slot === null || slot === void 0 ? void 0 : slot.startTime)).toDate() : null
            };
          }) : null,
          capacityDate: responseData === null || responseData === void 0 ? void 0 : (_responseData$capacit6 = responseData.capacitySlots) === null || _responseData$capacit6 === void 0 ? void 0 : _responseData$capacit6.capacityDate,
          interval: responseData === null || responseData === void 0 ? void 0 : (_responseData$capacit7 = responseData.capacitySlots) === null || _responseData$capacit7 === void 0 ? void 0 : _responseData$capacit7.interval,
          unavailableSlots: responseData !== null && responseData !== void 0 && (_responseData$capacit8 = responseData.capacitySlots) !== null && _responseData$capacit8 !== void 0 && _responseData$capacit8.unavailableSlots ? responseData === null || responseData === void 0 ? void 0 : (_responseData$capacit9 = responseData.capacitySlots) === null || _responseData$capacit9 === void 0 ? void 0 : (_responseData$capacit10 = _responseData$capacit9.unavailableSlots) === null || _responseData$capacit10 === void 0 ? void 0 : _responseData$capacit10.map(function (slot) {
            var _responseData$capacit11, _responseData$capacit12;

            return {
              startDateTime: slot !== null && slot !== void 0 && slot.startTime ? moment((responseData === null || responseData === void 0 ? void 0 : (_responseData$capacit11 = responseData.capacitySlots) === null || _responseData$capacit11 === void 0 ? void 0 : _responseData$capacit11.capacityDate) + " " + (slot === null || slot === void 0 ? void 0 : slot.startTime)).toDate() : null,
              endDateTime: slot !== null && slot !== void 0 && slot.endTime ? moment((responseData === null || responseData === void 0 ? void 0 : (_responseData$capacit12 = responseData.capacitySlots) === null || _responseData$capacit12 === void 0 ? void 0 : _responseData$capacit12.capacityDate) + " " + (slot === null || slot === void 0 ? void 0 : slot.endTime)).toDate() : null,
              lowInventory: slot === null || slot === void 0 ? void 0 : slot.lowInventory
            };
          }) : null
        } : null,
        times: responseData.times ? {
          lunch: responseData !== null && responseData !== void 0 && (_responseData$times = responseData.times) !== null && _responseData$times !== void 0 && _responseData$times.lunch ? {
            startDateTime: typeof responseData.times.lunch !== "boolean" && responseData.times.lunch.startTime ? moment(pickupDateStr + " " + responseData.times.lunch.startTime, "L HH:mm").toDate() : null,
            endDateTime: typeof responseData.times.lunch !== "boolean" && responseData.times.lunch.endTime ? moment(pickupDateStr + " " + responseData.times.lunch.endTime, "L HH:mm").toDate() : null
          } : null,
          dinner: responseData.times.dinner ? {
            startDateTime: typeof responseData.times.dinner !== "boolean" && responseData !== null && responseData !== void 0 && (_responseData$times2 = responseData.times) !== null && _responseData$times2 !== void 0 && (_responseData$times2$ = _responseData$times2.dinner) !== null && _responseData$times2$ !== void 0 && _responseData$times2$.startTime ? moment(pickupDateStr + " " + responseData.times.dinner.startTime, "L HH:mm").toDate() : null,
            endDateTime: typeof responseData.times.dinner !== "boolean" && responseData.times.dinner.endTime ? moment(pickupDateStr + " " + responseData.times.dinner.endTime, "L HH:mm").toDate() : null
          } : null
        } : null,
        restPermClosedDate: responseData !== null && responseData !== void 0 && responseData.restPermClosedDate ? parseDate(responseData === null || responseData === void 0 ? void 0 : responseData.restPermClosedDate) : null,
        requestedDate: responseData !== null && responseData !== void 0 && responseData.requestedDate ? parseDate(responseData === null || responseData === void 0 ? void 0 : responseData.requestedDate) : null,
        restaurantHolidayDates: responseData !== null && responseData !== void 0 && responseData.restaurantHolidays ? responseData === null || responseData === void 0 ? void 0 : (_responseData$restaur = responseData.restaurantHolidays.split("@")) === null || _responseData$restaur === void 0 ? void 0 : _responseData$restaur.map(function (dateStr) {
          try {
            var parts = dateStr.split("/");
            return moment("".concat(parts[2], "-").concat(parts[1], "-").concat(parts[0])).toDate();
          } catch (e) {// NOOP
          }

          return null;
        }) : null,
        restaurantAvailableDate: responseData !== null && responseData !== void 0 && responseData.restaurantAvailableDate ? parseDate(responseData === null || responseData === void 0 ? void 0 : responseData.restaurantAvailableDate) : null
      });
    }
  }, {
    key: "getCapacityTimeSlots",
    value: function () {
      var _getCapacityTimeSlots = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(restaurantId, pickupDate, orderType, nextAvailableSlot) {
        var commonQueryParams, locale, pickupDateStr, response;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                pickupDateStr = formatDate(pickupDate);
                _context4.next = 5;
                return this.axios.get(this.config.postfix.CAPACITY_TIMES_SLOTS, {
                  params: {
                    orderType: orderType,
                    nextAvailableSlot: nextAvailableSlot,
                    restaurantId: restaurantId,
                    pickupDate: pickupDateStr,
                    locale: locale
                  }
                });

              case 5:
                response = _context4.sent;
                return _context4.abrupt("return", response.data);

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getCapacityTimeSlots(_x11, _x12, _x13, _x14) {
        return _getCapacityTimeSlots.apply(this, arguments);
      }

      return getCapacityTimeSlots;
    }()
  }]);

  return Times;
}();

export { Times as default };